<template>
    <div>
  <v-container>
    <h3 class="mt-7 mx-3">My {{Investment.name}} Investment</h3>
 

   <!-- Invest layout -->
  <div class="container mt-4">
    <div class="row justify-content-center">
      <div class="col-lg-6">
        <div class="card fund">
          <div class="card-body card-product">
            <div class="text-center">
              <img width="215" height="139.47" :src="getImageUrl(Investment.farm_img_url)" class="img-fluid" alt="third"  />
            </div>
            <h5 class="card-title text-center mt-2">{{Investment.name}}</h5>

            <!-- number of units -->
            <!-- <form class="mt-3"> -->
              <div class="form-group">
                <label for="units">Number of Units</label>
                <input type="number" class="form-control input-style" required v-model="units" @input="check()">
              </div>
  
                <h6 class="card-text mt-4 text-color">Total Amount: <span style="font-weight: bold;">&#8358;{{total}}</span></h6>
                <h6 class="card-text text-color mt-3">Estimated returns: <span style="font-weight: bold;">&#8358;{{estimate}}</span></h6>
                <h6 class="card-text text-color mt-3">Duration: <span style="font-weight: bold;">{{Investment.duration}}</span></h6>
                <h6 class="card-text text-color mt-3">ROI:  <span style="font-weight: bold;">{{Investment.roi}}%</span></h6>
                <div class="text-center mt-4">
                 
                    <Rave
                            :email="fltEmail"
                            :reference="reference"
                            :amount="amounts"
                            :rave-key="raveKey"
                            :callback="callback"
                            :close="close"
                            :metadata="meta"
                            :subaccounts="subaccounts"
                            :paymentPlan="plan"
                            :customerFirstname="fname"
                            :customerLastname="lname"
                            paymentOptions="card,barter,account,ussd"
                            hostedPayemt="1"
                            customTitle="Investment Payment"
                            currency="NGN"
                            country="NG"
                          
                        > <button class="btn btn-fund" :disabled="isDisabled">Pay With Card</button></Rave>
                
                </div>

            <!-- </form> -->
            
          </div>
        </div>
      </div>
    </div>
  </div>

  </v-container>

  
    </div>
</template>

<script>
import Rave from 'vue-ravepayment';
export default {
  components: {
            Rave
        },
    data(){
    return{
      units:0,
       fltEmail: this.$store.state.auth.logindetails.data.email,
        loadFlt:false,
        raveKey:'FLWPUBK_TEST-2e36fe15dab9757843d16ab2731aba74-X',
        meta: [{
            metaname: 'Green Farms',
            metavalue: 'Investment Payment'
        }],
        sub: [
            {
                id: "1324"
            },
            {
                id: "1221"
            }
        ],
        plan: 2928,
        
        fname: this.$store.state.auth.logindetails.data.firstname,
        lname: this.$store.state.auth.logindetails.data.lastname,
        isDisabled:true
    }
  },
  methods:{
     getImageUrl(url){
      return url
    },
    Pay(event){
      event.preventDefault()
      this.$router.push('/invest')
    },
    close: function(){
      console.log("Payment closed")
    },
  callback: function(response){
    if(response.data.data.responsecode==="00"&& response.data.tx.txRef===this.reference){
        let raveId = response.data.tx.id
        let flwRef = response.data.tx.flwRef    
        this.$store.dispatch("PostTransactions", {
            "transRef":this.reference,
            "user_id":this.$store.state.auth.logindetails.data._id,
            "raveTransId":raveId,
            "flwRef":flwRef,
            "investment_id":this.$store.state.farm.investmentbyid._id,
            "duration":this.$store.state.farm.investmentbyid.duration,
            "investment_code":this.$store.state.farm.investmentbyid.investment_code,
            "amount_paid": this.amounts,
            "units_bought" : this.units,
            "estimated_return" : this.returns,
            "farm_id" : this.$store.state.farm.investmentbyid.farm_id,

        })
        .then(()=>{
        })
        .catch(()=>{
        })
    }else{
        console.log('Something went wrong')
    }
  },
  check(){
      if(this.units===0 || this.units<1){
        this.isDisabled = true
      }else{
        this.isDisabled = false
      }
    },
  },
  computed:{
    Investment(){
       return this.$store.state.farm.investmentbyid
    },
    reference(){
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for( let i=0; i < 10; i++ )
        text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    },
    total(){
      let x = this.units * parseFloat(this.Investment.cost)
      x = parseFloat(x).toFixed(2)
      x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return x
    },
    amounts(){
      let x = this.units * parseFloat(this.Investment.cost)
      return x
    },
    estimate(){
      let x = parseInt(this.Investment.roi)
      let y = (parseFloat(x/100) * (this.units * parseFloat(this.Investment.cost))) + parseFloat(this.units * parseFloat(this.Investment.cost))
      y = parseFloat(y).toFixed(2)
      y = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
     return y
    },
    returns(){
      let x = parseInt(this.Investment.roi)
      let y = (parseFloat(x/100) * (this.units * parseFloat(this.Investment.cost))) + parseFloat(this.units * parseFloat(this.Investment.cost))
      
     return y
    }
  },
  
  
}
</script>

<style scoped>
/* funds styles */
.fund{
    border:0;
    transition: all ease-in-out 0.6s;  
}
.btn-fund{
    background: #48c074;
    border-radius: 38.5px;
    color: #fff;
    padding: 10px 20px;
    transition: all 0.5s ;
  }
  .btn-fund.active{
    background: #fff;
    box-shadow: 0px -2px 10px rgba(255, 255, 255, 0.14), 0px 4.5px 10px rgba(255, 255, 255, 0.14);
    color: #48c074;
    border: 1px solid #48c074;
    transition: all 0.5s ;
  }
  .btn-fund:hover{
    background: #fff;
    box-shadow: 0px -2px 10px rgba(255, 255, 255, 0.14), 0px 4.5px 10px rgba(255, 255, 255, 0.14);
    color: #48c074;
    border: 1px solid #48c074;
  }
  .btn-fund.active:hover{
    background: #48c074;
    box-shadow: 0px -2px 10px rgba(255, 255, 255, 0.14), 0px 4.5px 10px rgba(255, 255, 255, 0.14);
    color: #fff;
  }
</style>